"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentfulGlobalFooterProps = void 0;

var _page = require("../page");

/**
 * @param {object} data
 * 
 * @returns {object}
 */
var getContentfulGlobalFooterProps = function getContentfulGlobalFooterProps(data) {
  var _data$fields$content, _data$fields, _content$reduce;

  var content = (_data$fields$content = data === null || data === void 0 ? void 0 : (_data$fields = data.fields) === null || _data$fields === void 0 ? void 0 : _data$fields.content) !== null && _data$fields$content !== void 0 ? _data$fields$content : [];
  var startingProps = {
    globalFooterContact: null,
    globalFooterLegal: null,
    globalFooterLinks: [],
    globalFooterLogo: null,
    globalFooterSales: null,
    globalFooterSignature: null,
    globalFooterSocialRebrand: null
  };
  var props = content === null || content === void 0 ? void 0 : (_content$reduce = content.reduce) === null || _content$reduce === void 0 ? void 0 : _content$reduce.call(content, function (acc, obj) {
    var fields = obj.fields;

    switch (fields === null || fields === void 0 ? void 0 : fields.id) {
      case 'contact-info':
        {
          acc.globalFooterContact = fields;
          break;
        }

      case 'legal-info-intl':
      case 'legal-info':
        {
          acc.globalFooterLegal = fields;
          break;
        }

      case 'sales-info':
        {
          acc.globalFooterSales = fields;
          break;
        }

      case 'glowforge-signature':
        {
          acc.globalFooterSignature = fields;
          break;
        }

      case 'social-links-rebrand':
        {
          acc.globalFooterSocialRebrand = fields;
          break;
        }

      case 'product-links':
      case 'company-links':
        {
          var title = fields.title,
              id = fields.id,
              listItems = fields.listItems;
          var items = listItems === null || listItems === void 0 ? void 0 : listItems.filter(function (item) {
            return (0, _page.getContentType)(item) === 'buttonLink';
          });
          var formattedLinks = {
            title: title,
            id: id,
            items: items
          };
          acc.globalFooterLinks.push(formattedLinks);
          break;
        }

      case 'glowforge-footer-logo':
        {
          var _fields$svgAsset;

          acc.globalFooterLogo = (_fields$svgAsset = fields.svgAsset) !== null && _fields$svgAsset !== void 0 ? _fields$svgAsset : null;
          break;
        }

      default:
        {
          break;
        }
    }

    return acc;
  }, startingProps);
  return props;
};

exports.getContentfulGlobalFooterProps = getContentfulGlobalFooterProps;